import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

export const state = {
  globals: null,
}

const namespaced = true

export const core = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
